import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ReactSession } from 'react-client-session';
import { useNavigate, useParams } from 'react-router-dom';
import Header from './header';
import Footer from './footer';
ReactSession.setStoreType("localStorage");

function App() {
    
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [selectedCountry, setSelectedCountry] = useState('ind');
    const [formData, setFormData] = useState([]);


    const login = async (e) => {
     e.preventDefault();
     setError('');
     const loginData = {
        email: email,
        pass : password
     }
     try{
        const response = await axios.post('https://demo.sninfoserv.com/api/customer/login/', loginData);
        //console.log(response.data);
        if(response.data.status === 'success'){
            sessionStorage.setItem('jmpiUserId', response.data.userId);
            window.location ='/my-account';
        }else{
            setError(response.data.msg);
            sessionStorage.setItem('jmpiUserId', 0);
        }

     }catch(error){
        setError({ error: error.message });
        sessionStorage.setItem('jmpiUserId', 0);
     }

    };

    const CountryName = (selectedCountry) => {
    
        let country;
        switch (selectedCountry) {
          case 'usa':
            country = 'United States';
            break;
          case 'uk':
            country = 'United Kingdom';
            break;
          case 'fra':
            country = 'France';
            break;
          case 'aus':
            country = 'Australia';
            break;
          case 'can':
            country = 'Canada';
            break;
          case 'nz':
            country = 'New Zealand';
            break;
          case 'ger':
            country = 'Germany';
            break;
          case 'net':
            country = 'Netherlands';
            break;
          case 'den':
            country = 'Denmark';
            break;
          case 'ita':
            country = 'Italy';
            break;
          case 'ire':
            country = 'Ireland';
            break;
          case 'bel':
            country = 'Belgium';
            break;
          case 'por':
            country = 'Portugal';
            break;
          case 'swe':
            country = 'Sweden';
            break;
          case 'sin':
            country = 'Singapore';
            break;
          case 'dub':
            country = 'Dubai';
            break;
          case 'mal':
            country = 'Malaysia';
            break;
          case 'ind':
            country = 'India';
            break;
          default:
            country = 'Select a Country';
            
        }

        return country;
        
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value
        });

        if(name === 'contry'){
            const contry = CountryName(value);
            setSelectedCountry(contry);
        }
    };

    const signUp = async (e) => {
        setError('');
        e.preventDefault();

     const loginData = {
        inputs: formData,
        country : selectedCountry
     }
     try{
        const response = await axios.post('https://demo.sninfoserv.com/api/customer/sign-in/', loginData);
        //console.log(response.data);
        if(response.data.status === 'success'){
            sessionStorage.setItem('jmpiUserId', response.data.userId);
            window.location ='/my-account';
        }else{
            setError(response.data.msg);
            sessionStorage.setItem('jmpiUserId', 0);
        }

     }catch(error){
        setError({ error: error.message });
        sessionStorage.setItem('jmpiUserId', 0);
     }

    };
  
    return (
        <div class="page-wrapper">
          <h1 class="d-none">Jampani Pickles</h1>
          <Header />  
          <main class="main order">
           
          <nav class="breadcrumb-nav">
                <div class="container">
                    <ul class="breadcrumb">
                        <li><a href="/">Home</a></li>
                        <li>My account</li>
                    </ul>
                </div>
            </nav>

            <div class="page-content" >
                <div class="container">
                    <div class="login-popup" style={{marginLeft: 'auto', marginRight: 'auto'}}>
                        <div class="tab tab-nav-boxed tab-nav-center tab-nav-underline">
                            <ul class="nav nav-tabs text-uppercase" role="tablist">
                                <li class="nav-item">
                                    <a href="#sign-in" class="nav-link active">Sign In</a>
                                </li>
                                <li class="nav-item">
                                    <a href="#sign-up" class="nav-link">Sign Up</a>
                                </li>
                            </ul>


                            <div class="tab-content">
                               
                                <div class="tab-pane active" id="sign-in">
                                  <form onSubmit={login}>  
                                    <div class="form-group">
                                        <label>Email ID *</label>
                                        <input type="email" class="form-control"  required  value={email} onChange={(e)=>setEmail(e.target.value)} />
                                    </div>
                                    <div class="form-group mb-0">
                                        <label>Password *</label>
                                        <input type="password" class="form-control"  required value={password} onChange={(e)=> setPassword(e.target.value)} />
                                    </div>
                                    <div class="form-checkbox d-flex align-items-center justify-content-between">
                                        <input type="checkbox" class="custom-checkbox" id="remember1" name="remember1" required="" />
                                        <label for="remember1">Remember me</label>
                                        <a href="/login">Lost your password?</a>
                                    </div>
                                    <button type="submit" class="btn btn-primary w-100">Sign In</button>
                                    </form>
                                    <p class="text-danger" align="center">{error.length > 0 && error}</p>
                                </div>
                               
                              

                                <div class="tab-pane" id="sign-up">
                                    <form onSubmit={signUp}>
                                    <div class="checkbox-content login-vendor">
                                        <div class="form-group mb-5">
                                            <label>First Name *</label>
                                            <input type="text" class="form-control" name="fName" value={formData.fName} onChange={handleChange} required />
                                        </div>
                                        <div class="form-group mb-5">
                                            <label>Last Name *</label>
                                            <input type="text" class="form-control" name="lName" value={formData.lName} onChange={handleChange} required />
                                        </div>
                                       
                                        <div class="form-group mb-5">
                                            <label>Phone Number *</label>
                                            <input type="text" class="form-control" name="number" value={formData.number} onChange={handleChange} required />
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Your email address *</label>
                                        <input type="text" class="form-control" name="email" value={formData.email} onChange={handleChange} required />
                                    </div>
                                    <div class="form-group mb-5">
                                        <label>Password *</label>
                                        <input type="text" class="form-control" name="password" value={formData.password} onChange={handleChange} required />
                                    </div>

                                    <div class="form-group mb-5">
                                        <label>Building/Flat/Home *</label>
                                        <input type="text" class="form-control" name="adrs1" value={formData.adrs1} onChange={handleChange} required />
                                    </div>

                                    <div class="form-group mb-5">
                                        <label>Area/Street/Location *</label>
                                        <input type="text" class="form-control" name="adrs2" value={formData.adrs2} onChange={handleChange} required />
                                    </div>

                                    <div class="form-group mb-5">
                                        <label>City *</label>
                                        <input type="text" class="form-control" name="city" value={formData.city} onChange={handleChange} required />
                                    </div>

                                    <div class="form-group mb-5">
                                        <label>State *</label>
                                        <input type="text" class="form-control" name="state" value={formData.state} onChange={handleChange} required />
                                    </div>

                                    <div class="form-group">
                                        <label>Country / Region *</label>
                                        <select name="contry" class="form-control form-control-md"  value={formData.contry} onChange={handleChange} >
                                      
                                            <option value="ind">India</option>
                                            <option value="usa">United States</option>
                                            <option value="uk">United Kingdom</option>
                                            <option value="fra">France</option>
                                            <option value="aus">Australia</option>
                                            <option value="can">Canada</option>
                                            <option value="nz">New Zealand</option>
                                            <option value="ger">Germany</option>
                                            <option value="net">Netherlands</option>
                                            <option value="den">Denmark</option>
                                            <option value="ita">Italy</option>
                                            <option value="ire">Ireland</option>
                                            <option value="bel">Belgium</option>
                                            <option value="por">Portugal</option>
                                            <option value="swe">Sweden</option>
                                            <option value="sin">Singapore</option>
                                            <option value="dub">Dubai</option>
                                            <option value="mal">Malaysia</option>
                                         </select>
                                    </div>

                                    <div class="form-group mb-5">
                                        <label>Zip *</label>
                                        <input type="text" class="form-control" name="zip" value={formData.zip} onChange={handleChange} required />
                                    </div>
                                    
                                    <button type="submit" class="btn btn-primary w-100">Sign Up</button>
                                    </form>
                                    <p class="text-danger mt-2" align="center">{error.length > 0 && error}</p>
                                </div>

                            </div>

                            
                        </div>
                    </div>
                </div>
            </div>
           
        </main>
          <Footer />
        </div>
  );
}

export default App;